import { AppointmentIFrame } from "components/organisms/AppointmentIFrame";

const Appointments = () => {
  return <AppointmentIFrame page="appointments" />;
};

export { Appointments };
